<template lang="pug">
	.css-editor(v-if="showed")
		.card
			.card-header
				i.fa.fa-pencil
				span {{domain}}
			.card-body
				.loading-wrapper(v-show="state === 'loading'")
					.icon.fa.fa-spinner.fa-spin
					span {{`Fetching ${domain} CSS`}}
				.content(v-show="state === 'loaded'" ref="editorElement" :style="{'background': 'red'}")
				.error(v-show="state === 'error'")
					span {{error}}
			.card-footer
				button.btn.btn-secondary(type="button" v-on:click="hide()") Cancel
				button.btn.btn-primary(v-show="state === 'loaded'" type="submit" v-on:click="save()") Save
</template>
<script>
	import Screen 						from './../../mixins/screen';
	import { Template } 				from "@/services/Template";
	import SetupSettings 				from "@/settings/settings.json";
	import { EditorView, basicSetup }	from "codemirror";
	import { css } 						from "@codemirror/lang-css";
	import { githubLight } 				from '@fsegurai/codemirror-theme-github-light';



	export default {
		name: "CssEditor",
		mixins: [Screen],
		screen: {
			updateOn: [],
			showed: false
		},
		data() {

			this.css = css;
			this.githubLightTheme = githubLight;
			this.Template = Template;
			this.basicSetup = basicSetup;

			return {
				domain: '',
				value: '',
				state: 'loading',
				error: ''
			}
		},
		methods: {
			collectData(action, domain) {

				this.state = 'loading';
				this.domain = domain;

				if (!domain) return;

				const folder = 'websites';
				const fileName = domain ? domain + '.css' : 'extra-styles.css';

				const url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${folder}/${fileName}`;

				fetch(url).then(response => {

					return response.text();

				}).then(css => {

					this.value = css;

					this.editor = new EditorView({
						parent: this.$refs.editorElement,
						doc: css,
						extensions: [this.basicSetup, this.css(), this.githubLightTheme]
					});

					this.state = 'loaded';

				}).catch(error => {

					this.state = 'error';
					this.error = error;

				});


			},

			save() {

				Template.uploadExtraStylesText(this.editor.state.doc.toString(), this.domain);

				this.hide();

			}
		}
	}
</script>

<style lang="sass">
	.css-editor
		position: absolute
		z-index: 2000
		background-color: rgba(0, 0, 0, 0.6)
		display: flex
		align-items: center
		justify-content: center
		width: 100%
		height: 100%

		>.card
			width: 80%
			min-height: 500px
			max-height: 80%

			>.card-body
				height: 500px

				>.content
					height: 100%

					>.cm-editor
						height: 100%

				>.loading-wrapper
					height: 100%
					display: flex
					flex-direction: column
					align-items: center
					justify-content: center

					.icon
						display: inline
						font-size: 30px

			>.card-footer
				display: flex
				justify-content: space-between

</style>
